import React from 'react';
import { useConstCallback } from '@uifabric/react-hooks';
import { CommandBar, Separator, CommandBarButton } from 'office-ui-fabric-react';
import { Persona, PersonaSize } from 'office-ui-fabric-react/lib/Persona';
import { Panel } from 'office-ui-fabric-react/lib/Panel';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import { getUser, logout } from '../../utils/auth';
import Link from '../../components/Link';
import styles from './NavigationBar.style';

const NavbarItemLink = ({ href, isActive, children }) => (
  <Link to={href} className={clsx('navbar-item', { 'is-active': isActive })}>
    {children}
  </Link>
);

NavbarItemLink.propTypes = {
  href: PropTypes.string.isRequired,
  isActive: PropTypes.bool,
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
};

NavbarItemLink.defaultProps = {
  isActive: false,
};

const NavigationBar = () => {
  const user = getUser();
  const name = user ? get(user.profile, 'name', '') : '';
  const email = user ? get(user.profile, 'email', '') : '';

  // Handling Panel State
  const [isOpen, setIsOpen] = React.useState(false);
  const openPanel = useConstCallback(() => setIsOpen(true));
  const dismissPanel = useConstCallback(() => setIsOpen(false));
  const isPartner = get(getUser(), 'profile.roles', []).includes('partner');

  const items = {
    left: [
      {
        key: 'logo',
        onRender: () => (
          <Link to="/" role="menuitem">
            <img src="/images/logo.png" alt="Microsoft Logo" className={styles.navbarImage} />
          </Link>
        ),
      },
      {
        key: 'separator',
        onRender: () => <Separator vertical className={styles.verticalStyle} />,
      },
      {
        key: 'title',
        onRender: () => <div className={styles.title}>Royalties Portal</div>,
      },
    ],
    right: [
      {
        key: 'privacyStatement',
        text: 'Microsoft Data Protection Notice',
        ariaLabel: 'menu item Microsoft Data Protection Notice',
        iconOnly: true,
        iconProps: { iconName: 'SecurityGroup' },
        href: `${
          isPartner
            ? 'http://go.microsoft.com/fwlink/?LinkId=521839'
            : 'https://go.microsoft.com/fwlink/?LinkId=518021'
        }`,
      },
      {
        key: 'faq',
        text: 'Faq',
        ariaLabel: 'menu item FAQ',
        iconOnly: true,
        iconProps: { iconName: 'QandA' },
        href: '/faq',
      },
      {
        key: 'right',
        ariaLabel: 'menu item Persona',
        onClick: openPanel,
        onRenderChildren: () => (
          <div>
            <Persona
              tabIndex={0}
              imageUrl=""
              size={PersonaSize.size32}
              text={name}
              onClick={openPanel}
              className={styles.personaCoin}
              hidePersonaDetails
            />
            <Panel
              headerText="Account"
              isLightDismiss
              isOpen={isOpen}
              onDismiss={dismissPanel}
              closeButtonAriaLabel="Close"
              className={styles.panel}
            >
              {/* To Do: Populate the user data post authentication */}
              <br />
              <Persona
                imageUrl=""
                text={name}
                secondaryText=""
                tertiaryText={email}
                size={PersonaSize.size72}
                coinSize={64}
              >
                <Separator />
              </Persona>
              <CommandBarButton className={styles.button} onClick={logout}>
                Log Out
              </CommandBarButton>
            </Panel>
          </div>
        ),
      },
    ],
  };

  return (
    <CommandBar items={items.left} farItems={user ? items.right : null} className={styles.root} />
  );
};

export default NavigationBar;
